<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    PROCESSOS ATA DIREX
                </span>
            </b-card-header>

            <b-card-body>

                <app-tabela
                    :itens="processosatadirexLista"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"

                >
                    <template slot="botoes">
                        <b-button-group class="float-right" >
                            <Cad-Processos-Ata-Direx
                                @listarProcessos="listar()"
                                :modoCadastro="true"
                                :ProcessoAtaDirexPai=null
                                v-if="$temAcessoView('ATADIREX-12')"
                            >
                            </Cad-Processos-Ata-Direx>
                        </b-button-group>
                    </template>

                    <template slot="nuValorGlobalProcesso" slot-scope="data">
                        <p class="text-right m-0">
                            {{ data.nuValorGlobalProcesso | currency }}
                        </p>
                    </template>
                    <template slot="situacaoProcesso" slot-scope="data">
                        <app-status
                            :status="data.situacaoProcesso.toUpperCase()"
                        ></app-status>
                    </template>

                    <template slot="acoes" slot-scope="data">
                        <span class="text-danger float-left mr-1">
                           <Cad-Cancelar-Processo-Ata-Direx
                                @listarProcessos="listar()"
                                :ProcessoAtaDirexPai="data"
                                :processoCancelado="data.processoCancelado"
                                :idAta="data.idAtaDirex"
                                v-if="nuSituacaoAta==1"
                            >
                            </Cad-Cancelar-Processo-Ata-Direx>
                        </span>

                        <span class="text-primary float-left mr-1">
                           <Cad-Processos-Ata-Direx
                                @listarProcessos="listar()"
                                :modoCadastro="false"
                                :ProcessoAtaDirexPai="data"
                                :processoCancelado="data.processoCancelado"
                                v-if="$temAcessoView('ATADIREX-13') && (nuSituacaoAta==1)"
                            >
                            </Cad-Processos-Ata-Direx>
                        </span>

                        <span class="text-success float-left mr-1">
                           <Anexos-Processo
                                @listarProcessos="listar()"
                                :processoAtaDirex="data"
                                :idProcesso="data.idProcessoAta"
                                :processoCancelado="data.processoCancelado"
                                v-if="$temAcessoView('ATADIREX-14') && (nuSituacaoAta==1)"
                            >
                            </Anexos-Processo>
                        </span>

                        <span class="text-primary float-left mr-1">
                           <Processo-Ata-Direx-Detalhe
                                @listarProcessos="listar()"
                                :ProcessoAtaDirexPai="data"
                                :processoCancelado="data.processoCancelado"
                            >
                            </Processo-Ata-Direx-Detalhe>
                        </span>

                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>


<script>
import AtaDirexServicos from './AtaDirexServicos'
import CadProcessosAtaDirex from './cadastro/CadProcessosAtaDirex.vue'
import CadCancelarProcessoAtaDirex from './cadastro/CadCancelarProcessoAtaDirex.vue'
import AnexosProcesso from './AnexosProcessoAtaDirex.vue'
import ProcessoAtaDirexDetalhe from './detalhes/ProcessoAtaDirexDetalhes.vue'

export default {

    components:{
        CadProcessosAtaDirex,
        CadCancelarProcessoAtaDirex,
        AnexosProcesso,
        ProcessoAtaDirexDetalhe
    },

    data() {
        return {
            processosatadirexLista:[],
            itensPorPagina: 5,
            nuSituacaoAta:this.$route.params.nuSituacaoAta,
            campos: [
                /*{
                    key: 'check',
                    label: 'Selecione'
                },*/
                {
                    key: 'nuFolhaAtaDirex',
                    label: 'Folha da Ata',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuProcesso',
                    label: 'Processo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeSolicitante',
                    label: 'Solicitante',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoProcesso',
                    label: 'Situação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tipoContrato',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuValorGlobalProcesso',
                    label: 'Valor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                },
            ]
        }
    },

    methods: {
        listar(){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ListarProcessosAtaDirex(this.$route.params.idAtaDirex).then(response => {
                if (response) {
                    if (response.success) {
                        this.processosatadirexLista = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    created() {
        this.listar()
    },
}
</script>
